import BaseBoilerplatePromoModal from 'src/components/Promotions/BaseBoilerplatePromoModal.svelte';
import { PROMOTIONS } from 'src/constants';
import type { ModalConfig } from 'src/types/Modals';
import { format } from 'svelte-i18n';
import { get } from 'svelte/store';

export const ShellyBirthdayCampaignModalConfig = (): ModalConfig => ({
	id: 'shellyBirthdayCampaign',
	component: BaseBoilerplatePromoModal,
	props: {
		showModal: true,
		urlPath:
			'pages/shelly-birthday?utm_source=shellyapp&utm_medium=referral&utm_campaign=shelly_7th_birthday',
		imageUrl: './images/shelly-birthday-7-confetti.png',
		modalTitle: get(format)('modal_title_happy_shelly_birthday'),
		heading: get(format)('text_primary_heading_campaign_1'),
		discount: '30%',
		dateSentence: get(format)('sentence_celebrate_with_us', {
			values: {
				datePrimarySpan: `<span class="text-primary text-600">${get(format)('span_from_24_to_30_july')}</span>`,
			},
		}),
		afterText: get(format)('text_smarten_up_your_home'),
	},
	rules: [
		{
			check: () => {
				const now = new Date().getTime();
				return (
					now >= PROMOTIONS.SHELLY_BIRTHDAY_CAMPAIGN.START_DATE &&
					now < PROMOTIONS.SHELLY_BIRTHDAY_CAMPAIGN.END_DATE
				);
			},
			expected: true,
		},
	],
});
